import React from 'react';

function CatalogueIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M11.7711 7.2738L12.9608 4.72568L19.3312 7.69992L18.1415 10.248L11.7711 7.2738Z'
				fill='#CF004F'
			/>
			<path
				d='M3.52893 16.6153L16.2739 22.5584L23.9999 5.98997L11.255 0L3.52893 16.6153ZM15.2537 19.7551L6.3322 15.595L6.92648 14.3205L15.848 18.4807L15.2537 19.7551ZM16.4422 17.2062L7.52076 13.046L8.11504 11.7715L17.0365 15.9317L16.4422 17.2062ZM17.6309 14.6573L8.70946 10.497L9.30374 9.22256L18.2251 13.3828L17.6309 14.6573ZM21.1967 7.01025L18.8195 12.1082L9.89802 7.94803L12.2753 2.85014L21.1967 7.01025Z'
				fill='#CF004F'
			/>
			<path
				d='M14.1562 23.1229L1.65998 17.2961L7.08028 5.67188H0V24H14.1562V23.1229Z'
				fill='#CF004F'
			/>
		</svg>
	);
}

export default CatalogueIcon;
